/* eslint-disable react-hooks/exhaustive-deps */
import EventRegistrationBanner from "Components/common/Banner/EventRegistrationBanner";
import ReCaptcha from "Components/common/captcha";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import Routes from "Routes/routes";
import { WEBINAR_EVENT_DATE } from "Static/constant";
import { captchaStoreValue } from "Stores/captcha";
import { DateUtils } from "Utils/DateUtils";
import MessageBridge, { MessageTypes } from "Utils/MessageBridge";
import "./Utils/chromeExtValidator";

// Component to handle route commands from Shell and sync URL back to Shell
const RouteHandler = () => {
  const history = useHistory();

  useEffect(() => {
    const cleanup = MessageBridge.listen({
      [MessageTypes.REDIRECT]: (payload) => {
        if (payload.path) {
          history.push(payload.path);
        }
      },
      [MessageTypes.SHOW_INTERCOM_CHAT]: () => {
        if (window.Intercom) {
          window.Intercom("show");
        }
      }
    });
    return cleanup;
  }, [history]);

  useEffect(() => {
    // Sync current URL to Shell on mount
    MessageBridge.sendToShell(MessageTypes.SYNC_URL, {
      path: window.location.pathname + window.location.search
    });

    // Sync every subsequent navigation to Shell
    const unlisten = history.listen((location) => {
      MessageBridge.sendToShell(MessageTypes.SYNC_URL, {
        path: location.pathname + location.search
      });
    });
    return unlisten;
  }, [history]);

  return null;
};

const MainApp = observer(() => {
  let isEventExpired = DateUtils.isEventExpired(WEBINAR_EVENT_DATE);

  const [eventRegistered, setEventRegistered] = useState(false);

  localStorage.removeItem("newUserSignUp");

  // const loadIntercomChat = () => {
  //   const {
  //     name = "",
  //     email = "",
  //     userLoggedIn = "",
  //     firstName = "",
  //     lastName = "",
  //     intercomEncryptKey = ""
  //   } = userDetail?.userInfo || {};
  //   if (userLoggedIn !== "") {
  //     let data = {
  //       app_id: INTERCOM_CHAT_API_KEY,
  //       custom_launcher_selector: "#my_custom_link"
  //     };
  //     if (email) {
  //       data = {
  //         ...data,
  //         name,
  //         email,
  //         first_name: firstName || lastName,
  //         user_hash: intercomEncryptKey?.toLowerCase() || ""
  //       };
  //     }
  //     const {
  //       inFreePlan = false,
  //       email: hasEmailFlag = "",
  //       createTs = ""
  //     } = userDetail?.userFeatureFlag || {};
  //     if (hasEmailFlag) {
  //       const userPlanType = inFreePlan
  //         ? "Free User"
  //         : !inFreePlan
  //         ? "Paid User"
  //         : "--";
  //       data.plan = userPlanType;
  //       data.signup_date = createTs;
  //     }
  //     window.intercomSettings = data;
  //     initIntercomChat(INTERCOM_CHAT_API_KEY);
  //     initIntercomShowHideOption();
  //   }
  // };

  // useEffect(() => {
  //   loadIntercomChat();
  // }, [userDetail.userFeatureFlag, userDetail?.userInfo]);

  return (
    <div
      className={`mainContent  ${!isEventExpired && !eventRegistered ? "showEventBanner" : ""
        }`}
    >
      {captchaStoreValue.showCaptcha && <ReCaptcha />}
      {!isEventExpired && !eventRegistered ? (
        <div className="eventBanner">
          {!isEventExpired && !eventRegistered && (
            <EventRegistrationBanner setEventRegistered={setEventRegistered} />
          )}
        </div>
      ) : (
        ""
      )}
      <Router>
        <RouteHandler />
        <Routes />
      </Router>
    </div>
  );
});

export default MainApp;
